import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

// The Headless UI Portal component is missing support for containers.
// See: https://github.com/tailwindlabs/headlessui/discussions/666

type PortalParameters = Parameters<typeof createPortal>;

export interface PortalProps extends React.HTMLAttributes<HTMLElement> {
  container?: PortalParameters[1];
  key?: PortalParameters[2];
}

const Portal = ({ children, container: containerProp, key }: PortalProps) => {
  const [container, setContainer] = useState<PortalParameters[1] | undefined>(containerProp);

  useEffect(() => {
    if (!container) {
      setContainer(document.getElementById("visualping-portal-root") ?? document.body);
    }
  }, [container]);

  return container ? createPortal(children, container, key) : null;
};

Portal.displayName = Portal.name;

export default Portal;
